const publicPaths = new Set(['/user/login', '/callback', '/comment-debug']);

export const isPublicPath = (pathname: string) => publicPaths.has(pathname);
